import React from 'react';
import * as _ from 'lodash';
import { FieldImageService } from '../services/FieldImages';
import { layoutInit } from '../canvas/keyPlan/';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { EventType } from '../utilities/EventManager';
import {
  ArrowIcon,
  SolidLineTypeIcon,
  LineDotIcon,
  LineDashIcon,
  ToolUndoIcon,
  ToolRedoIcon,
  ToolSelectIcon,
  ToolFontIcon,
  ToolPartsIcon,
  ToolShapeIcon,
  ToolShapeCircleIcon,
  ToolShapeSquareIcon,
  ToolShapePolygonIcon,
  ToolLineIcon,
  ToolLineNormalIcon,
  ToolLinePolylineIcon,
  ToolLineFreeHandIcon,
  ToolPanIcon,
  ToolCutIcon,
  ToolCopyIcon,
  ToolPasteIcon,
  ToolGroupIcon,
  ToolUnGroupIcon,
  ToolMoveFrontIcon,
  ToolMoveBackIcon,
  ToolLockIcon,
  ToolUnLockIcon,
  ToolDeleteIcon,
  ToolZoomDownIcon,
  ToolZoomUpIcon,
  ToolShapeSectorIcon,
  ToolPenIcon,
  CheckIcon,
} from '../canvas/icon/LayoutIcon';
import Tippy from '../components/ReactTippy';
import { drawing } from '../canvas/common/drawing';
import {
  defaultColor,
  defaultStrokeSize,
  presetColors,
  presetStrokeSize
} from '../canvas/common/freehandUtil';


export default class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.stylesheets = ['/drawing/css/canvas.css'];
    this.webkitTapHighlightColorTransparent = {
      WebkitTapHighlightColor: 'transparent',
    };
    this.state = {
      hasObjectSelected: false,
      isTouchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
      showSettings: false,
      color: drawing.freehandState.color,
      strokeSize: drawing.freehandState.strokeSize,
      penModalTop: 0,
      penModalLeft: 0,
    };
    this.handleUpdateStateEvent = this.handleUpdateStateEvent.bind(this);

    this.modalRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.penBtnRef = React.createRef();
  }

  loadStylesheets(link) {
    const l = document.createElement('link');
    l.rel = 'stylesheet';
    l.media = 'all';
    l.href = link;
    l.className = 'load-stylesheet';
    document.head.appendChild(l);
  }

  removeStylesheets() {
    const stylesheets = document.head.getElementsByClassName('load-stylesheet');
    const cnt = stylesheets.length;
    for (let i = 0; i <= cnt; i++) {
      const remove = document.head.getElementsByClassName('load-stylesheet');
      if (remove[0] !== undefined) {
        document.head.removeChild(remove[0]);
      }
    }
  }

  // iPad画面が動かないようにする
  preventBehavior(e) {
    e.preventDefault();
  }

  componentDidMount() {
    document.getElementsByClassName('global-header')[0].style.display = 'none';
    document.getElementById('master-navi').style.display = 'none';
    document.getElementById('func-navi--item1').style.display = 'none';
    document.getElementById('master-navi').classList.remove('show');
    document.getElementById('func-navi--item1').classList.remove('show');
    this.removeStylesheets();
    _.each(this.stylesheets, stylesheet => {
      this.loadStylesheets(stylesheet);
    });
    const fieldId = sessionStorage.getItem('field_id');
    FieldImageService.keyplan(fieldId, {}).then(resp => {
      if (resp.result) {
        const fieldImages = resp.data.entities.field_images;
        _.each(fieldImages, fieldImage => {
          if (fieldImage.category_code == this.props.param[1]) {
            layoutInit(fieldImage.image_url);
          }
        });
      }
    });
    const editCanvas = document.querySelector('.layout-grid');
    editCanvas.addEventListener('touchmove', this.preventBehavior, {
      passive: false,
    });
    window.addEventListener(
      EventType.LAYOUT_LOADING,
      this.handleUpdateStateEvent
    );
    document.addEventListener('pointerdown', this.handleClickOutside);
    window.addEventListener('openFreehandPalette', this.openFreehandPalette);
    window.addEventListener('closeFreehandPalette', this.closeFreehandPalette);
    window.addEventListener('resetFreehandPalette', this.resetFreehandPalette);
  }

  componentWillUnmount() {
    window.removeEventListener(
      EventType.LAYOUT_LOADING,
      this.handleUpdateStateEvent
    );
    document.removeEventListener('pointerdown', this.handleClickOutside);
  }

  handleUpdateStateEvent = event => {
    const { hasObjectSelected } = event.detail;
    this.setState({ hasObjectSelected });
  };

  ShowToolTip = ({ message, children, disable = false }) => {
    const { isTouchDevice } = this.state;
    return (
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        arrow={true}
        delay={[100, 0]}
        placement='bottom'
        followCursor={true}
        html={
          <div
            className='layout-tippy-tooltip'
            dangerouslySetInnerHTML={{ __html: message }}
          ></div>
        }
        disable={disable || isTouchDevice}
      >
        {children}
      </Tippy>
    );
  };

  preventDefault = e => e.preventDefault();

  handleChangeColor = (newColor) => {
    this.setState({
      color: newColor,
    })
    drawing.freehandState.color = newColor;
  };

  handleChangeStrokeSize = (newSize) => {
    this.setState({
      strokeSize: newSize
    })
    drawing.freehandState.strokeSize = newSize;
  };

  handleClickOutside(event) {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.closeFreehandPalette();
    }
  }

  openFreehandPalette = () => {
    this.setState({ showSettings: true });
    this.repositionFreehandPalette();
  };
  
  closeFreehandPalette = () => {
    this.setState({ showSettings: false });
  }
  
  resetFreehandPalette = () => {
    this.handleChangeColor(defaultColor);
    this.handleChangeStrokeSize(defaultStrokeSize);
  }

  repositionFreehandPalette = () => {
    requestAnimationFrame(() => {
      const rect = this.penBtnRef.current.getBoundingClientRect();
      const parent = this.penBtnRef.current.offsetParent;
      if (!rect || !parent) {
        return;
      }
      const parentRect = parent.getBoundingClientRect();
      this.setState({
        penModalTop: rect.bottom - parentRect.top - 15,
        penModalLeft: rect.left - parentRect.left,
      });
    });
  }

  render() {
    const { hasObjectSelected } = this.state;
    const iconArrow = (top, isDropdownEl) => {
      let className = '';
      if (top) {
        className = 'rotate-to-top';
      }
      if (isDropdownEl) {
        className += ' i-2x';
      } else {
        className += ' i-2x_2';
      }
      return (
        <i className={`${className}`}>
          <ArrowIcon />
        </i>
      );
    };

    return (
      <div id='main' className='main layout_main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - キープラン画像編集</title>
        </Helmet>
        <div
          className='main__header'
          onClick={this.preventDefault}
          style={this.webkitTapHighlightColorTransparent}
        >
          <div className='layout-header'>
            <div className='layout-header__title'>キープラン画像編集</div>
            <div className='layout-header__menu layout-header__menu__keyplan'>
              <div className='layout-header__info'>
                <label>配置数 </label>
                <span className='object_count' />
                <span className='object_max_count' />
              </div>
              <div className='layout-header__close-button'>
                <button className='btn--sm--stay sys_keyplan_submit'>
                  反映
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='main__body layout_body'>
          <div className='layout'>
            <div className='tool-item-list tool-crane__dropdown'>
              <div className='tool-crane__body parts_group_dropdown'>
                <ul className='dropdown-tool-list parts_group_list' />
              </div>
            </div>
            <div
              className='layout-tool-tabs layout-tool-fix'
              onClick={this.preventDefault}
              style={this.webkitTapHighlightColorTransparent}
            >
              <ul>
                <li
                  className='tab-link active'
                  id='tab-tool-home__link'
                  data-tab='tab-tool-home'
                >
                  ホーム
                </li>
                {this.ShowToolTip({
                  message: '編集するオブジェクトを選択してください。',
                  disable: hasObjectSelected,
                  children: (
                    <li
                      className='tab-link disable'
                      id='tab-tool-edit__link'
                      data-tab='tab-tool-edit'
                    >
                      オブジェクトの編集
                    </li>
                  ),
                })}
              </ul>
            </div>
            <div
              className='layout-tool layout-tool-fix'
              onClick={this.preventDefault}
              style={this.webkitTapHighlightColorTransparent}
            >
              <div className='tab-content active' id='tab-tool-home'>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '戻す(Ctrl+Z)',
                      children: (
                        <button className='tool-btn toolbar-undo btn-icon'>
                          <i className='i-3x' alt='１つ戻る'>
                            <ToolUndoIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>１つ戻る</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'やり直す(Ctrl+Y)',
                      children: (
                        <button className='tool-btn toolbar-redo btn-icon'>
                          <i className='i-3x' alt='１つ進む'>
                            <ToolRedoIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>１つ進む</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを選択(A)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip tool-select btn-icon'
                          data-id='tool-select'
                        >
                          <i className='i-3x' alt='選択'>
                            <ToolSelectIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>選択</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'テキストを配置(T)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip tool-font btn-icon'
                          data-id='tool-font'
                        >
                          <i className='i-3x' alt='テキスト'>
                            <ToolFontIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>テキスト</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <div className='tool-item-list tool-crane'>
                      <div className='tool-crane__header'>
                        <button
                          className='tool-btn tool-parts-button tool-btn__arrow-down btn-icon'
                          data-id='tool-parts-button'
                        >
                          <i className='i-3x' alt='部品配置'>
                            <ToolPartsIcon />
                          </i>
                          {iconArrow(false, false)}
                        </button>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>アイテム</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item' ref={this.penBtnRef}>
                    {this.ShowToolTip({
                      message: '描画(B)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip tool-btn__arrow-down btn-icon'
                          data-id='tool-freehand'
                        >
                          <i className='i-3x' alt='描画'>
                            <ToolPenIcon />
                          </i>
                          {iconArrow(false, false)}
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>描画</span>
                      </div>
                    </div>
                  </div>
                  {this.state.showSettings && (
                    <div
                      ref={this.modalRef}
                      style={{
                        position: 'absolute',
                        top: this.state.penModalTop,
                        left: this.state.penModalLeft,
                        background: '#FFFFFF',
                        zIndex: 1000,
                        width: '178px',
                        borderRadius: '4px',
                        border: '1px solid #CCCCCC',
                        boxShadow: '0px 2px 2px 0px #00000033',
                      }}
                    >
                      <div style={{ padding: '8px' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <label style={{ fontSize: '11px', color: '#1a1a1a', lineHeight: '32px' }}>線の太さ: {this.state.strokeSize}pt</label>
                          <div style={{ width: '60px', height: `${this.state.strokeSize}px`, marginLeft: 'auto', background: this.state.color }}></div>
                        </div>
                        <div style={{ position: 'relative' }}>
                          <style>
                            {`
                              input[type="range"].custom-slider::-webkit-slider-thumb {
                                appearance: none;
                                width: 12px;
                                height: 12px;
                                background: #2681FF;
                                border-radius: 50%;
                                box-shadow: 0px 2px 2px 0px #00000033;
                                cursor: pointer;
                                margin-top: -5px;
                                transform: translateX(var(--thumb-offset, 0px));
                              }

                              input[type="range"].custom-slider::-moz-range-thumb {
                                width: 12px;
                                height: 12px;
                                background: #2681FF;
                                border-radius: 50%;
                                box-shadow: 0px 2px 2px 0px #00000033;
                                cursor: pointer;
                                transform: translateX(var(--thumb-offset, 0px));
                              }

                              input[type="range"].custom-slider::-webkit-slider-runnable-track {
                                height: 2px;
                                background: linear-gradient(to right, #2681FF 0%, #2681FF ${(presetStrokeSize.indexOf(this.state.strokeSize) / 6) * 100}%, rgba(194, 221, 255, 0.38) ${(presetStrokeSize.indexOf(this.state.strokeSize) / 6) * 100}%, rgba(194, 221, 255, 0.38) 100%);
                                border-radius: 2px;
                              }
                            `}
                          </style>
                          <input
                            type="range"
                            min="0"
                            max={`${presetStrokeSize.length-1}`}
                            step="1"
                            value={presetStrokeSize.indexOf(this.state.strokeSize)}
                            onChange={(e) => this.handleChangeStrokeSize(presetStrokeSize[Number(e.target.value)])}
                            className="custom-slider"
                            style={{
                              width: '100%',
                              height: '2px',
                              appearance: 'none',
                              background: 'transparent',
                              outline: 'none',
                              padding: '10px 0',
                              boxSizing: 'content-box',
                              cursor: 'pointer',
                              margin: 0,
                              '--thumb-offset': `${[-5, -4, -1, 0, 1, 4, 5][presetStrokeSize.indexOf(this.state.strokeSize)]}px`
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            top: '10px',
                            left: '0px',
                            right: '0',
                            height: '10px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            pointerEvents: 'none',
                            width: '100%',
                          }}>
                            {presetStrokeSize.map((_, index) => (
                              <span
                                key={index}
                                style={{
                                  width: '2px',
                                  height: '2px',
                                  backgroundColor: '#555',
                                  borderRadius: '50%',
                                  transform: 'translateX(0%)',
                                  background: 'rgba(194, 221, 255, 0.8)',
                                  visibility: index === presetStrokeSize.indexOf(this.state.strokeSize) ? 'hidden' : 'visible',
                                }}
                              />
                            ))}
                          </div>
                        </div>
                      </div>
                      <div style={{ padding: '8px' }}>
                        <label style={{ fontSize: '11px', color: '#1a1a1a' }}>色</label>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
                          {presetColors.map((c) => (
                            <div
                              key={c}
                              onClick={() => this.handleChangeColor(c)}
                              style={{
                                width: '32px',
                                height: '32px',
                                backgroundColor: c,
                                position: 'relative',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}
                            >
                              {c === 'transparent' && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    pointerEvents: 'none',
                                  }}
                                >
                                  <svg
                                    width="100%"
                                    height="100%"
                                    viewBox="0 0 32 32"
                                    preserveAspectRatio="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <line
                                      x1="0"
                                      y1="0"
                                      x2="32"
                                      y2="32"
                                      stroke="#000000"
                                      strokeWidth="1"
                                    />
                                  </svg>
                                </div>
                              )}
                              {c === this.state.color && <CheckIcon />}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className='layout-tool__item'>
                    <div className='tool-item--sm tool-item-list tool-object-list'>
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-shape-button tool-btn__arrow-down btn-icon'
                          data-id='tool-shape-button'
                        >
                          <i
                            className='i-3x tool-object-icon icon-default'
                            alt='図形配置'
                          >
                            <ToolShapeIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-circle'
                            alt='円配置'
                          >
                            <ToolShapeCircleIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-square'
                            alt='四角配置'
                          >
                            <ToolShapeSquareIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-polygon'
                            alt='多角形配置'
                          >
                            <ToolShapePolygonIcon />
                          </i>
                          <i
                            className='i-3x tool-object-icon icon-sector'
                            alt='扇形配置'
                          >
                            <ToolShapeSectorIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-circle'
                          >
                            {this.ShowToolTip({
                              message: '	円(C)',
                              children: (
                                <button className='img-tool-object tool-circle'>
                                  <ToolShapeCircleIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-square'
                          >
                            {this.ShowToolTip({
                              message: '四角(R)',
                              children: (
                                <button className='img-tool-object tool-square'>
                                  <ToolShapeSquareIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-polygon'
                          >
                            {this.ShowToolTip({
                              message: '多角形(M)',
                              children: (
                                <button className='img-tool-object tool-polygon'>
                                  <ToolShapePolygonIcon />
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-sector'
                          >
                            {this.ShowToolTip({
                              message: '扇形(F)',
                              children: (
                                <button className='img-tool-object tool-sector'>
                                  <ToolShapeSectorIcon />
                                </button>
                              ),
                            })}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span className='selected-object-label icon-default'>
                          図形
                        </span>
                        <span className='selected-object-label icon-circle'>
                          円
                        </span>
                        <span className='selected-object-label icon-square'>
                          四角
                        </span>
                        <span className='selected-object-label icon-polygon'>
                          多角形
                        </span>
                        <span className='selected-object-label icon-sector'>
                          扇形
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    <div className='tool-item--sm tool-item-list tool-line-list'>
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-line-button tool-btn__arrow-down btn-icon'
                          data-id='tool-line-button'
                        >
                          <i
                            className='i-3x tool-line-icon icon-default'
                            alt='線配置'
                          >
                            <ToolLineIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-line-normal'
                            alt='直線配置'
                          >
                            <ToolLineNormalIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-polyline'
                            alt='折れ線配置'
                          >
                            <ToolLinePolylineIcon />
                          </i>
                          <i
                            className='i-3x tool-line-icon icon-freehand'
                            alt='自由線配置'
                          >
                            <ToolLineFreeHandIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item  sys_tooltip'
                            data-id='tool-line-normal'
                          >
                            {this.ShowToolTip({
                              message: '	直線(L)',
                              children: (
                                <button className='img-tool-line i-tool-line-1 btn-icon'>
                                  <i className='i-3x' alt='線配置'>
                                    <ToolLineNormalIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                          <li
                            className='dropdown-tool-list__item sys_tooltip'
                            data-id='tool-polyline'
                          >
                            {this.ShowToolTip({
                              message: '折れ線(Alt+L)',
                              children: (
                                <button className='img-tool-line i-tool-line-2 btn-icon'>
                                  <i className='i-3x'>
                                    <ToolLinePolylineIcon />
                                  </i>
                                </button>
                              ),
                            })}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span className='selected-line-label icon-default'>
                          線
                        </span>
                        <span className='selected-line-label icon-line-normal'>
                          直線
                        </span>
                        <span className='selected-line-label icon-polyline'>
                          折れ線
                        </span>
                        <span className='selected-line-label icon-freehand'>
                          自由線
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '背景を移動(Space)',
                      children: (
                        <button
                          className='tool-btn sys_tooltip btn-icon'
                          data-id='tool-pan'
                        >
                          <i className='i-3x' alt='背景移動'>
                            <ToolPanIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>背景移動</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group layout-tool__group--end'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを切り取り(Ctrl+X)',
                      children: (
                        <button className='tool-btn toolbar-cut btn-icon'>
                          <i className='i-3x' alt='切り取り'>
                            <ToolCutIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>カット</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをコピー(Ctrl+C)',
                      children: (
                        <button className='tool-btn toolbar-copy btn-icon'>
                          <i className='i-3x' alt='コピー'>
                            <ToolCopyIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>コピー</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを貼り付け(Ctrl+V)',
                      children: (
                        <button className='tool-btn toolbar-paste btn-icon'>
                          <i className='i-3x' alt='貼り付け'>
                            <ToolPasteIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>貼り付け</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='tab-content' id='tab-tool-edit'>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-background'>
                      <div className='btn-pick-color btn-pick-color-background _selected __none' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __empty'
                              data-id='empty'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>塗り</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-background-transparent'
                      className='tool-item--sm'
                    >
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='塗りの透明度'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='0%'>
                              0%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='5%'>
                              5%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='10%'>
                              10%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='15%'>
                              15%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='20%'>
                              20%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='25%'>
                              25%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='30%'>
                              30%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='35%'>
                              35%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='40%'>
                              40%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='45%'>
                              45%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='50%'>
                              50%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='55%'>
                              55%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='60%'>
                              60%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='65%'>
                              65%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='70%'>
                              70%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='75%'>
                              75%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='80%'>
                              80%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='85%'>
                              85%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='90%'>
                              90%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='95%'>
                              95%
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='100%'>
                              100%
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>透明度</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-foreground'>
                      <div className='btn-pick-color btn-pick-color__line _selected __111111' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __empty'
                              data-id='empty'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __f2f2f2'
                              data-id='f2f2f2'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の色</span>
                      </div>
                    </div>
                  </div>
                  <div
                    className='layout-tool__item tool-setting-style'
                    id='dropdown-border-section'
                  >
                    <div
                      id='dropdown-border-style'
                      className='tool-item--sm tool-item-list'
                    >
                      <div className='tool-item--sm__header'>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon'
                          data-id='tool-line-style-button'
                          data-value='1'
                        >
                          <i className='i-3x'>
                            <SolidLineTypeIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon dotted-line-style'
                          data-id='tool-line-style-button'
                          data-value='2'
                        >
                          <i className='i-3x'>
                            <LineDotIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                        <button
                          className='tool-btn tool-line-style-button tool-btn__arrow-down btn-icon dashed-line-style'
                          data-id='tool-line-style-button'
                          data-value='3'
                        >
                          <i className='i-3x'>
                            <LineDashIcon />
                          </i>
                          {iconArrow(false)}
                        </button>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-solid_line'
                          >
                            <button
                              className='tool-list-btn tool-solid_line btn-icon'
                              data-value='実線'
                            >
                              <i className='i-3x'>
                                <SolidLineTypeIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>実線</span>
                            </span>
                          </li>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-dotted-line'
                          >
                            <button
                              className='tool-list-btn tool-dotted-line btn-icon'
                              data-value='点線'
                            >
                              <i className='i-3x'>
                                <LineDotIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>点線</span>
                            </span>
                          </li>
                          <li
                            className='dropdown-tool-list__item dropdown-tool-list__item--has-icon'
                            data-id='tool-dashed-line'
                          >
                            <button
                              className='tool-list-btn btn-icon tool-dashed-line'
                              data-value='鎖線'
                            >
                              <i className='i-3x'>
                                <LineDashIcon />
                              </i>
                            </button>
                            <span className='sub-label'>
                              <span className='sub-label'>鎖線</span>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の種類</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div id='dropdown-border' className='tool-item--sm'>
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='線の太さ'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='1pt'>
                              1pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='4pt'>
                              4pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='8pt'>
                              8pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='12pt'>
                              12pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='16pt'>
                              16pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='20pt'>
                              20pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='32pt'>
                              32pt
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>線の太さ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-border-arrow'
                      className='tool-arrow-type tool-item--sm'
                    >
                      <div className='tool-arrow-type__header'>
                        <div className='input-spin--sm' alt='矢印の種類'>
                          <div className='tool-arrow-type__value'>
                            <input type='hidden' />
                            <span className='tool-arrow-type__input-text'>
                              なし
                            </span>
                          </div>
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-arrow-type__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-1'
                              data-value='0'
                            >
                              なし
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-2'
                              data-value='1'
                            >
                              終点
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-3'
                              data-value='2'
                            >
                              始点
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-arrow-type i-tool-arrow-type-4'
                              data-value='3'
                            >
                              両端
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>矢印の向き</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div
                      id='dropdown-border-arrow-size'
                      className='tool-line-size tool-item--sm'
                    >
                      <div className='tool-line-size__header'>
                        <div className='input-spin--sm' alt='矢印のサイズ'>
                          <div className='tool-line-size__value'>
                            <input type='hidden' />
                            <span className='tool-arrow-size__input-text img-tool-line-size selected-icon'>
                              小
                            </span>
                          </div>
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-line-size__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-1'
                              data-value='10'
                            >
                              小
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-2'
                              data-value='20'
                            >
                              中
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item '>
                            <button
                              className='img-tool-line-size i-tool-arrow-size-3'
                              data-value='30'
                            >
                              大
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>矢印の</span>
                        <span>サイズ</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group'>
                  <div className='layout-tool__item tool-setting-style'>
                    <div className='Palette pick-color toolbar-picker-text'>
                      <div className='btn-pick-color btn-pick-color__text _selected __111111' />
                      <div className='_palette'>
                        <ul>
                          <li>
                            <div
                              className='_color sys_select_color __none'
                              data-id='none'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __f2f2f2'
                              data-id='f2f2f2'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __cccccc'
                              data-id='cccccc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __aaaaaa'
                              data-id='aaaaaa'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __111111'
                              data-id='111111'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffffcc'
                              data-id='ffffcc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffbeda'
                              data-id='ffbeda'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff00cc'
                              data-id='ff00cc'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff0202'
                              data-id='ff0202'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __800000'
                              data-id='800000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ff570d'
                              data-id='ff570d'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffab00'
                              data-id='ffab00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __ffea00'
                              data-id='ffea00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __99cc00'
                              data-id='99cc00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __1bff00'
                              data-id='1bff00'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __008000'
                              data-id='008000'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __0034ff'
                              data-id='0034ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __00a3ff'
                              data-id='00a3ff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __d7eeff'
                              data-id='d7eeff'
                            />
                          </li>
                          <li>
                            <div
                              className='_color sys_select_color __8900ff'
                              data-id='8900ff'
                            />
                          </li>
                        </ul>
                      </div>
                      <div className='dropdown-icon'>{iconArrow(false)}</div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>文字の色</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item tool-setting-style'>
                    <div id='dropdown-font-size' className='tool-item--sm'>
                      <div className='tool-item--sm__header'>
                        <div className='input-spin--sm' alt='文字の大きさ'>
                          <input readOnly type='text' />
                          <div className='btn-spin--sm'>
                            <div className='btn-icon select-up'>
                              {iconArrow(true, true)}
                            </div>
                            <div className='dropdown-icon btn-icon select-down'>
                              {iconArrow(false, true)}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='tool-item--sm__body'>
                        <ul className='dropdown-tool-list'>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='9pt'>
                              9pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='10pt'>
                              10pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='11pt'>
                              11pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='12pt'>
                              12pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='14pt'>
                              14pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='18pt'>
                              18pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='24pt'>
                              24pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list'>
                            <button className='tool-list-btn' data-value='28pt'>
                              28pt
                            </button>
                          </li>
                          <li className='dropdown-tool-list__item tool-item-list '>
                            <button className='tool-list-btn' data-value='32pt'>
                              32pt
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>文字の</span>
                        <span>サイズ</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='layout-tool__group layout-tool__group--end'>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをグループ化(Ctrl+G)',
                      children: (
                        <button className='tool-btn toolbar-group btn-icon'>
                          <i className='i-3x' alt='グループ化'>
                            <ToolGroupIcon />
                          </i>
                        </button>
                      ),
                    })}
                    {this.ShowToolTip({
                      message: 'クループ化を解除(Ctrl+Shift+G)',
                      children: (
                        <button className='tool-btn toolbar-ungroup btn-icon'>
                          <i className='i-3x' alt='グループ解除'>
                            <ToolUnGroupIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label label-group'>
                        <span>グループ化</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '前面へ移動(Alt+] )<br/>最前面へ移動 ( ] )',
                      children: (
                        <button className='tool-btn toolbar-move-front btn-icon'>
                          <i className='i-3x' alt='最前面へ'>
                            <ToolMoveFrontIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>最前面へ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: '背面へ移動(Alt+[ )<br/>最背面へ移動( [ )',
                      children: (
                        <button className='tool-btn toolbar-move-back btn-icon'>
                          <i className='i-3x' alt='最背面へ'>
                            <ToolMoveBackIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>最背面へ</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトをロック(Ctrl+Shift+L) ',
                      children: (
                        <button className='tool-btn toolbar-lock btn-icon'>
                          <i className='i-3x' alt='オブジェクトのロック'>
                            <ToolLockIcon />
                          </i>
                        </button>
                      ),
                    })}
                    {this.ShowToolTip({
                      message: ' ロック状態を解除(Ctrl+Shift+L)',
                      children: (
                        <button className='tool-btn toolbar-unlock btn-icon'>
                          <i className='i-3x' alt='オブジェクトのロック解除'>
                            <ToolUnLockIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label label-lock'>
                        <span>ロック</span>
                      </div>
                    </div>
                  </div>
                  <div className='layout-tool__item'>
                    {this.ShowToolTip({
                      message: 'オブジェクトを削除(delete)',
                      children: (
                        <button className='tool-btn toolbar-delete btn-icon'>
                          <i className='i-3x' alt='削除'>
                            <ToolDeleteIcon />
                          </i>
                        </button>
                      ),
                    })}
                    <div className='layout-tool__label'>
                      <div className='label'>
                        <span>削除</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className='layout-grid grid-1'
              onClick={this.preventDefault}
              style={this.webkitTapHighlightColorTransparent}
            >
              <div className='layout-canvas__workspace edit_canvas'>
                <canvas className='' id='canvas' />
              </div>
            </div>
          </div>
        </div>

        <div
          className='layout-tool-footer layout-tool-footer__keyplan'
          onClick={this.preventDefault}
          style={this.webkitTapHighlightColorTransparent}
        >
          <div className='layout-tool__group layout-tool__group--end'>
            <div className='layout-tool__item'>
              <button className='tool-btn toolbar-zoomdown btn-icon'>
                <i className='i-3x' alt='ズーム-'>
                  <ToolZoomDownIcon />
                </i>
              </button>
              <div className='layout-tool__label'>
                <div className='label'>
                  <span>縮小</span>
                </div>
              </div>
            </div>
            <div className='layout-tool__item'>
              <button className='tool-btn toolbar-zoomup btn-icon'>
                <i className='i-3x' alt='ズーム+'>
                  <ToolZoomUpIcon />
                </i>
              </button>
              <div className='layout-tool__label'>
                <div className='label'>
                  <span>拡大</span>
                </div>
              </div>
            </div>
            <div className=''>
              <div className='layout-tool__item'>
                <div id='dropdown-zoom-level' className='tool-item--sm'>
                  <div className='tool-item--sm__header'>
                    <div className='input-spin--sm' alt='zoom'>
                      <input readOnly type='text' />
                      <div className='btn-spin--sm'>
                        <div className='btn-icon select-up-reverse'>
                          {iconArrow(true, true)}
                        </div>
                        <div className='dropdown-icon btn-icon select-down-reverse'>
                          {iconArrow(false, true)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='tool-item--sm__body select-zoom'>
                    <ul className='dropdown-tool-list'>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='800%'>
                          800%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='700%'>
                          700%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='600%'>
                          600%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='500%'>
                          500%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='400%'>
                          400%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='300%'>
                          300%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='250%'>
                          250%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='200%'>
                          200%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='175%'>
                          175%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='150%'>
                          150%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='125%'>
                          125%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='100%'>
                          100%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='75%'>
                          75%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='50%'>
                          50%
                        </button>
                      </li>
                      <li className='dropdown-tool-list__item tool-item-list'>
                        <button className='tool-list-btn' data-value='25%'>
                          25%
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className='layout-tool__label'>
                  <div className='label'>
                    <span>表示倍率</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id='modal-dialog-add-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ追加
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名</div>
                <div className='dialog-layout-parts__input'>
                  <input
                    name='group_name'
                    type='text'
                    placeholder='グループ名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog sys_submit'>追加する</button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-edit-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ編集
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名</div>
                <div className='dialog-layout-parts__input'>
                  <input type='hidden' name='group_id' />
                  <input
                    type='text'
                    name='group_name'
                    placeholder='グループ名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
              <button className='btn-layout-dialog--effective sys_submit'>
                更新
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-delete-parts-group' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>
                部品グループ削除確認
              </span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループ名：</div>
                <div className='label' name='group_name' />
              </div>
              <div className='dialog-layout-parts__form'>
                <div className='label'>グループを削除しますか？</div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-add-parts' className='modal'>
          <div className='dialog-layout-parts dialog--modal'>
            <div className='dialog-layout-parts__header'>
              <span className='dialog-layout-parts__title'>部品編集</span>
            </div>
            <div className='dialog-layout-parts__body'>
              <div className='dialog-layout-parts__form'>
                <div className='label'>部品名</div>
                <div className='dialog-layout-parts__input'>
                  <input type='hidden' name='group_id' />
                  <input type='hidden' name='parts_id' />
                  <input
                    type='text'
                    name='parts_name'
                    placeholder='部品名を入力'
                  />
                </div>
              </div>
            </div>
            <div className='dialog-layout-parts__footer'>
              <button className='btn-layout-dialog--sub sys_cancel'>
                戻る
              </button>
              <button className='btn-layout-dialog--negative sys_delete'>
                削除
              </button>
              <button className='btn-layout-dialog--effective sys_submit'>
                更新
              </button>
            </div>
          </div>
        </div>

        <div id='modal-dialog-popup-message' className='modal'>
          <div className='dialog-md dialog--modal'>
            <div className='dialog-md__header'>
              <span className='dialog-md__title'>メッセージ</span>
            </div>
            <div className='dialog-md__body text-center message_text' />
            <div className='dialog-md__footer'>
              <button className='btn--sub sys_cancel'>戻る</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/KeyplanLayout.jsx